<ngx-ui-loader [loaderId]="loaderId"></ngx-ui-loader>
